import React from "react";

import * as S from "./styles";

const ItemSapPending = ({ data, setSelectedItem }) => {
  return (
    <S.Container>
      <S.Item>
        <S.Value>{data?.sap_name || data?.invoice_name}</S.Value>
        <S.Value>UN: {data?.unit}</S.Value>
        <S.Value>NF: {data?.invoice_quantity}</S.Value>
        <S.Value>SAP: {data?.sap_quantity || "---"}</S.Value>
        <S.Value className="diff">
          DIF: {data?.diff !== null ? data?.diff : "---"}
        </S.Value>
        <S.IconWarning />
        {data?.invoice_item_id && (
          <S.CommentButton
            onClick={() => setSelectedItem({ ...data, type: "SAP" })}
          >
            <S.IconComment />
          </S.CommentButton>
        )}
      </S.Item>
      <S.PercentBox>
        {data?.diff
          ? `${((data.diff * 100) / data.sap_quantity).toFixed(1)}%`
          : "---"}
      </S.PercentBox>
    </S.Container>
  );
};

export default ItemSapPending;
